import React from "react";

export const NumberField = ({ value, onChange, label, id = label }) => {
  return (
    <>
      <label>
        {label}
        <input
          id={id}
          type="number"
          value={value}
          onChange={onChange}
          min={0}
          max={10000}
          step={1}
        />
      </label>
    </>
  );
};

export default NumberField;
